import { useEffect, useState } from "react";
import { SEARCH_DEBOUNCE_MS } from "../constants/config";

/**
 * Debounce a rapidly changing value (typically a search input) so that
 * downstream effects (network requests, filters) only fire after the user
 * pauses typing.
 */
export const useDebouncedValue = (value, delay = SEARCH_DEBOUNCE_MS) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);

  return debounced;
};
